module.exports = __webpack_public_path__ + "static/img/guide.315513d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide.png
// module id = Rzs6
// module chunks = 1